<template>
  <BasePage title="404">
    <Basic404/>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import Basic404 from './Basic404.vue'

export default {
  name: 'HTTP404',
  components: {
    BasePage,
    Basic404,
  },
}
</script>



// WEBPACK FOOTER //
// HTTP404.vue?2a12327f